import {Component, HostListener, OnInit} from '@angular/core';
import {EmailService} from '../../../services/email.service';
import {Email, RecipientMailingResult} from '../../../types/email-data.types';
import {CustomStyleService} from '../../../services/custom-style.service';
import {UrlService} from '../../../services/url.service';

declare const moment: any;

@Component({
    selector: 'mailing-result-modal',
    templateUrl: './mailing-result-modal.component.html',
    styleUrls: ['./mailing-result-modal.component.scss']
})
export class MailingResultComponent implements OnInit {
    showModal = false;
    data: Email;
    sf: StatusFilter;

    constructor(public es: EmailService,
                public urlService: UrlService,
                public customStyleService: CustomStyleService) {}

    ngOnInit(): void {
        this.data   = Object.assign({}, this.es.emailInMailingResultModal);
        this.sf = new StatusFilter(this.data.recipients);

        setTimeout(() => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        this.es.isMailingResultModalShow  = false;
        this.es.emailInMailingResultModal = null;
        this.es.showSearchInstructionsModal = false;
        this.urlService.modalClosed.emit();
    }

    isBuildingHalfChecked(item): boolean {
        return (
            !item.tenantsChecked ||
            !item.ownerOnChecked ||
            !item.ownerOffChecked ||
            !item.residentOwnerChecked ||
            !item.residentOnlyNotOnDeedChecked ||
            !item.ownerFamilyChecked ||
            !item.guestChecked ||
            !item.offsiteResidentChecked ||
            !item.residentChecked ||
            !item.occupantChecked ||
            !item.notSetChecked ||
            !item.unitManagerCount ||
            !item.staffChecked ||
            item.tenantsHalfChecked ||
            item.ownerOnHalfChecked ||
            item.ownerOffHalfChecked ||
            item.residentOwnerHalfChecked ||
            item.residentOnlyNotOnDeedHalfChecked ||
            item.ownerFamilyHalfChecked ||
            item.guestHalfChecked ||
            item.offsiteResidentHalfChecked ||
            item.residentHalfChecked ||
            item.occupantHalfChecked ||
            item.notSetHalfChecked ||
            item.unitManagerHalfChecked ||
            item.staffHalfChecked
        );
    }

    isResidentHalfChecked(item): boolean {
        return !item.tenantsChecked || !item.ownerOnChecked || item.tenantsHalfChecked || item.ownerOnHalfChecked;
    }

    orderBy(fieldName: string, event: any) {
        if (this.data.recipients.length < 2) return;

        const clickedElement = (event.target.className === 'footable-sort-indicator') ? event.target.parentElement : event.target;
        const parent = clickedElement.parentElement;
        let order = 'asc';

        if (!clickedElement.className) {
            Array.prototype.forEach.call(parent.children, (item) => {
                item.removeAttribute('class');
            });
        }
        if (clickedElement.classList.contains('footable-sorted')) {
            clickedElement.classList.remove('footable-sorted');
            clickedElement.classList.add('footable-sorted-desc');
            order = 'desc';
        } else {
            clickedElement.classList.remove('footable-sorted-desc');
            clickedElement.classList.add('footable-sorted');
            order = 'asc';
        }

        this.data.recipients.sort((a: any, b: any) => {
            if (a[fieldName] < b[fieldName]) {
                return order == 'asc' ? -1 : 1;
            } else if (a[fieldName] > b[fieldName]) {
                return order == 'asc' ? 1 : -1;
            } else {
                return 0;
            }
        });
    }

    printEmailInfo(printRightAway): void {
        const firstPart = '<!DOCTYPE html>\n' +
            '<html>\n' +
            '    <head>\n' +
            '        <style>\n' +
            '            table{ \n' +
            '                border: 1px solid black;\n' +
            '                border-spacing: 0;\n' +
            '                border-collapse: collapse;\n' +
            '                font-family: Arial;\n' +
            '                margin-bottom: 10px;\n' +
            '            }\n' +
            '            th{ \n' +
            '                border-bottom: 1px solid black;\n' +
            '                font-size: small;\n' +
            '                padding: 10px\n' +
            '            }\n' +
            '            td{ \n' +
            '                border: 1px solid black;\n' +
            '                padding: 10px\n' +
            '                font-size: small;\n' +
            '            }\n' +
            '            body{ ' +
            '                padding: 20px !important;' +
            '            }' +
            '            .text-left{ text-align: left; }\n' +
            '            .first-th{ \n' +
            '                border-right: 1px solid black;\n' +
            '            }\n' +
            '            .valid-periods-cell b{ font-size: 21px; }\n' +
            '            .main-wrapper{' +
            '                width: 100%;' +
            '                margin-top: 10px;' +
            '            }' +
            '            .logo {' +
            '                       position: absolute;' +
            '                       top: 20px;' +
            '                       right: 20px;' +
            '                       height: 90px;' +
            '                       width: 200px;' +
            '                       background: #fff center center / contain no-repeat;' +
            `                       background-image: url(${this.customStyleService.obj.logo}) !important;` +
            '            }' +
            '        </style>\n' +
            '        <title>List Of Recipients</title>' +
            '        <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">' +
            '        <meta charset="UTF-8">\n' +
            '    </head>\n' +
            '    <body  style="-webkit-print-color-adjust:exact;">' +
            '        <h1>List of Recipients</h1>' +
            `        <div>${moment(this.data.createdAt).format('DD-MM-YYYY hh:MM A (Z)')} ${this.data.pmName}</div>` +
        '            <div class="logo"></div>' +
            '        <div class="main-wrapper">' +
            '            <table class="table table-striped table-borderless">' +
            '                <tr>' +
            '                    <th class="text-left first-th">Subject</th>' +
            '                    <th class="text-left first-th">Created By</th>' +
            '                    <th class="text-left first-th">Created On</th>' +
            '                    <th class="text-left first-th">Recipients Count</th>' +
            '                    <th class="text-left first-th">Sent</th>' +
            '                    <th class="text-left first-th">Opened</th>' +
            '                    <th class="text-left first-th">Clicked</th>' +
            '                </tr>' +
            '                <tr>' +
            `                    <td class="text-left">${this.data.subject}</td>` +
            `                    <td class="text-left">${this.data.pmName}</td>` +
            `                    <td class="text-left">${moment(this.data.createdAt).format('DD.MM.YYYY hh:MM A')}</td>` +
            `                    <td class="text-left">${this.data.recipientsCount}</td>` +
            `                    <td class="text-left">${this.data.sentCount}</td>` +
            `                    <td class="text-left">${this.data.openedCount}</td>` +
            `                    <td class="text-left">${this.data.clickedCount}</td>` +
            '                </tr>' +
            '            </table>\n';
        let template =  '<table class="table table-striped table-borderless">\n' +
                        '    <tr>\n' +
                        '        <th class="text-left first-th">Unit</th>' +
                        '        <th class="text-left first-th">Building</th>' +
                        '        <th class="text-left first-th">Resident</th>' +
                        '        <th class="text-left first-th">Type</th>' +
                        '        <th class="text-left first-th">Email</th>' +
                        '        <th class="text-left first-th">Status</th>' +
                        '    </tr>\n';
        const lastPart = '</div>\n' +
            '    </body>\n' +
            '</html>';

        this.sf.recipients.forEach(r => {
            template += '<tr>\n' +
            `                <td class="text-left">${r.suiteName}</td>` +
            `                <td class="text-left">${r.buildingName}</td>` +
            `                <td class="text-left">${r.name}</td>` +
            `                <td class="text-left">
                                ${r.humanReadableType()}
                            </td>` +
            `               <td class="text-left">${r.email}</td>` +
            `               <td class="text-left">
                                ${r.status === 'in_progress' ? 'In Progress' : ''}
                                ${r.status === 'sent' ? 'Unread' : ''}
                                ${r.status === 'error' ? 'Error' : ''}
                                ${r.status === 'opened' ? 'Opened' : ''}
                                ${r.status === 'clicked' ? 'Clicked' : ''}
                            </td>` +
            '            </tr>\n';
        });
        template += '</table>\n';
        const tab = window.open();
        tab.document.write(firstPart + template + lastPart);
        if(printRightAway) {
            setTimeout(() => {
                tab.stop();
                tab.print();
                tab.close();
            }, 500);
        }
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}

class StatusFilter {
    searchStr: string;
    statuses      = ['in_progress', 'sent', 'error', 'opened', 'clicked'];
    in_progress   = true;
    sent          = true;
    error         = true;
    opened        = true;
    clicked       = true;
    showDropdown  = true;
    //recipients: RecipientMailingResult[];

    constructor(public recipients: RecipientMailingResult[]) {}

    filterResidents(): RecipientMailingResult[] {
        function searchCondition(searchStr = '', resident: RecipientMailingResult) {
            searchStr = searchStr.toLowerCase();
            let regex = '^';
            for(let i = 0; i < searchStr.length; i++) {
                if(searchStr[i] === '*')
                    regex += '.*';
                else if(searchStr[i] === '~')
                    regex += '.{1}';
                else
                    regex += searchStr[i];
            }
            regex += '$';
            return !searchStr || (
                resident.suiteName.toLowerCase().indexOf(searchStr) !== -1 ||
                resident.buildingName.toLowerCase().indexOf(searchStr) !== -1 ||
                resident.name.toLowerCase().indexOf(searchStr) !== -1 ||
                resident.email.toLowerCase().indexOf(searchStr) !== -1 ||
                resident.suiteName.toLowerCase().match(regex) ||
                resident.buildingName.toLowerCase().match(regex) ||
                resident.name.toLowerCase().match(regex) ||
                resident.email.toLowerCase().match(regex)
            );
        }

        return this.recipients.filter((resident: RecipientMailingResult) => {
            return (
                searchCondition(this.searchStr, resident) && (
                    (this.in_progress && resident.status === 'in_progress') ||
                    (this.sent        && resident.status === 'sent')        ||
                    (this.error       && resident.status === 'error')       ||
                    (this.opened      && resident.status === 'opened')      ||
                    (this.clicked     && resident.status === 'clicked')
                )
            );
        });
    }

    getLabel(status): string {
        if (status === 'in_progress') return 'In Progress';
        if (status === 'sent')        return 'Unread';
        if (status === 'error')       return 'Error';
        if (status === 'opened')      return 'Opened';
        if (status === 'clicked')     return 'Clicked';
    }

    toggleCheckedAll(state: boolean): void {
        this.in_progress = this.sent = this.error = this.opened = this.clicked = state;
    }

    isAllStatusChecked() {
        return (this.in_progress === true && this.sent === true && this.error === true && this.opened === true && this.clicked === true);
    }

    getUsersCountByStatus(status: string): number {
        if(status == 'opened')
            return this.recipients.filter(r => (r.status === 'clicked' || r.status === 'opened')).length;
        else
            return this.recipients.filter(r => r.status === status).length;
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/email/mailing-result-modal/mailing-result-modal.component.ts